const API_BASE = process.env.REACT_APP_API_BASE || 'https://flyship-backend-409206511578.us-central1.run.app';

export default API_BASE;
